import { message } from 'antd';

export default (file) => {
  if (file.type.split('/')[0] !== 'image') {
    message.error('Uploaded file is not an image');
  }
  return false;
};
